module.exports = __webpack_public_path__ + "img/file_icon.b984257.svg";